import React from "react";
import { Link } from "react-router-dom";

export default function Footer() {
    return (
        <footer className="w-full border-t bg-white text-sm text-gray-500">
            <div className="max-w-7xl mx-auto px-6 py-4 flex flex-col md:flex-row justify-between items-center gap-2">

                <div className="text-center md:text-left">
                    © {new Date().getFullYear()} NORMA HACCP – Tutti i diritti riservati
                </div>

                <div className="flex gap-4">
                    <Link
                        to="/termini"
                        className="hover:text-gray-800 transition-colors"
                    >
                        Termini e Condizioni
                    </Link>

                    <Link
                        to="/privacy"
                        className="hover:text-gray-800 transition-colors"
                    >
                        Privacy Policy
                    </Link>
                </div>
            </div>
        </footer>
    );
}